module.exports = __webpack_public_path__ + "fonts/OpenSansCondensed-Light.e1803ad.ttf";